/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:37:20 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-03-19 18:32:02
 */
import bmapStyle from "@/config/bmapStyle";
import echarts from 'echarts'
import * as mapv from 'mapv';
// import  '@/common/BMapLib.js';
/**
 * 初始化地图
 * @param {*} el 
 * @param {*} center 
 * @param {*} zoom 
 */
function createMaps(el, center, zoom,style='normal') {
    console.log('🗺️ 地图初始化参数:', { style, center, zoom });

    // 先确定要使用的样式
    let selectedStyle = null;
    if(style=="report"){
        selectedStyle = bmapStyle.reportSystemStyle;
        console.log('✅ 使用 reportSystemStyle 样式');
    }else if(style=="land"){
        selectedStyle = bmapStyle.landSystemStyle;
        console.log('✅ 使用 landSystemStyle 样式');
    }else{
        selectedStyle = bmapStyle.darkstyle;
        console.log('✅ 使用 darkstyle 样式');
    }

    // 关键修复：在创建地图时就传入样式配置，避免闪烁
    let mapType = {
        enableMapClick: false,
        style: {
            styleJson: selectedStyle
        }
    };

    let map = new BMapGL.Map(el, mapType);
    map.centerAndZoom(new BMapGL.Point(center[0], center[1]), zoom);

    // 立即设置样式，确保在地图渲染前就应用
    try {
        map.setMapStyleV2({
            styleJson: selectedStyle
        });
        console.log('✅ 地图样式立即应用成功');
    } catch (error) {
        console.error('❌ 样式设置失败:', error);
    }

    map.enableScrollWheelZoom(true);
    return map;
}


/**
 * 绘制地图多边形
 * @param {_MAP} map
 * @param {string} boundary :'1223.2,32323.2;133232.4,3432432.6;'
 * @param {*Object} param2 选填  {styles:{...}||events:{...} }
 */
function drawPolygon(boundary, {styles,events} = {}, map) {
    if (!boundary) return;
    let aryPoint = boundary.split(';');
    let aryP = [];
    aryPoint.forEach((item, index) => {
        // 过滤空字符串
        if (item && item.trim()) {
            let coords = item.split(',');
            if (coords.length >= 2) {
                let lng = parseFloat(coords[0]);
                let lat = parseFloat(coords[1]);
                // 确保坐标是有效数字
                if (!isNaN(lng) && !isNaN(lat)) {
                    let point = new BMapGL.Point(lng, lat);
                    aryP.push(point);
                }
            }
        }
    });

    // 如果没有有效坐标点，返回
    if (aryP.length === 0) {
        console.warn('No valid coordinates found in boundary:', boundary);
        return;
    }

    //样式 - BMapGL 使用驼峰命名
    let styleConfig = Object.assign({}, {
        fillColor: "#FFCC02",
        fillOpacity: 0.6,
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeColor: "#FFCC02"
    }, styles);

    //默认事件
    let eventsConfig = Object.assign({}, {
        click: null,
        mouseover: null,
        mouseout: null,
        dblclick: null,
    }, events);

    let polygonObj = {
        type: "polygon",
        item: new BMapGL.Polygon(aryP, styleConfig),
    };

    map.addOverlay(polygonObj.item);

    let keys = Object.keys(eventsConfig);
    //绑定事件
    keys.forEach(keyName => {
        let event = eventsConfig[keyName];
        if (event) {
            polygonObj.item.addEventListener(keyName, (e) => {
                eventsConfig[keyName](polygonObj.item, styleConfig,e)
            });
        }
    });
    return {
        item: polygonObj.item,
        config: styleConfig,
        point:aryP,
    };

}

/**
 * 使用百度地图 API 绘制行政区域边界
 * @param {_MAP} map - 地图实例
 * @param {string} cityName - 城市名称，如 "北京市"、"上海市"
 * @param {Object} options - 配置选项
 * @param {Object} options.styles - 多边形样式
 * @param {Object} options.events - 事件绑定
 * @returns {Promise} 返回 Promise，resolve 绘制的多边形数组
 */
function drawBoundaryByName(map, cityName, {styles, events} = {}) {
    return new Promise((resolve, reject) => {
        if (!cityName) {
            reject(new Error('城市名称不能为空'));
            return;
        }

        // 样式配置
        let styleConfig = Object.assign({}, {
            fillColor: "#FFCC02",
            fillOpacity: 0.6,
            strokeOpacity: 1,
            strokeWeight: 2,
            strokeColor: "#FFCC02"
        }, styles);

        // 事件配置
        let eventsConfig = Object.assign({}, {
            click: null,
            mouseover: null,
            mouseout: null,
            dblclick: null,
        }, events);

        const bdary = new BMapGL.Boundary();
        const polygons = [];

        bdary.get(cityName, function(rs) {
            if (!rs || !rs.boundaries || rs.boundaries.length === 0) {
                console.warn(`未找到城市 ${cityName} 的边界数据`);
                reject(new Error(`未找到城市 ${cityName} 的边界数据`));
                return;
            }

            const boundaries = rs.boundaries;

            // 遍历所有边界（某些城市可能有多个边界，如岛屿）
            for (let i = 0; i < boundaries.length; i++) {
                const points = [];
                const coordsStr = boundaries[i];
                const coords = coordsStr.split(';');

                coords.forEach(coord => {
                    if (coord && coord.trim()) {
                        const [lng, lat] = coord.split(',').map(parseFloat);
                        if (!isNaN(lng) && !isNaN(lat)) {
                            points.push(new BMapGL.Point(lng, lat));
                        }
                    }
                });

                if (points.length > 0) {
                    const polygon = new BMapGL.Polygon(points, styleConfig);
                    map.addOverlay(polygon);

                    // 绑定事件
                    Object.keys(eventsConfig).forEach(keyName => {
                        const event = eventsConfig[keyName];
                        if (event) {
                            polygon.addEventListener(keyName, (e) => {
                                eventsConfig[keyName](polygon, styleConfig, e);
                            });
                        }
                    });

                    polygons.push({
                        item: polygon,
                        config: styleConfig,
                        points: points,
                        cityName: cityName
                    });
                }
            }

            resolve(polygons);
        });
    });
}

/**
 * 绘制全国省级行政区划边界
 * 使用百度地图 BMapGL.DistrictLayer 绘制
 * @param {_MAP} map - 地图实例
 * @param {Object} options - 配置选项
 * @returns {Object} 返回行政区划图层对象
 */
function drawChinaProvinceBoundaries(map, options = {}) {
    // 默认样式配置
    const defaultStyles = {
        strokeColor: '#0668BA',
        strokeWeight: 1,
        strokeOpacity: 0.5,
        fillColor: '#0668BA',
        fillOpacity: 0.05
    };

    const styles = Object.assign({}, defaultStyles, options.styles || {});

    // 创建行政区划图层
    const districtLayer = new BMapGL.DistrictLayer({
        name: 'china_province',
        kind: 1, // 1 表示省级
        fillColor: styles.fillColor,
        fillOpacity: styles.fillOpacity,
        strokeColor: styles.strokeColor,
        strokeWeight: styles.strokeWeight,
        strokeOpacity: styles.strokeOpacity
    });

    // 添加图层到地图
    map.addDistrictLayer(districtLayer);

    return districtLayer;
}

/**
 * 批量绘制多个城市的行政边界
 * @param {_MAP} map - 地图实例
 * @param {Array} cityNames - 城市名称数组
 * @param {Object} options - 配置选项
 * @returns {Promise} 返回 Promise，resolve 所有绘制的多边形
 */
function drawMultipleBoundaries(map, cityNames, {styles, events} = {}) {
    if (!Array.isArray(cityNames) || cityNames.length === 0) {
        return Promise.reject(new Error('城市名称数组不能为空'));
    }

    const promises = cityNames.map(cityName =>
        drawBoundaryByName(map, cityName, {styles, events})
    );

    return Promise.all(promises).then(results => {
        // 合并所有结果
        return results.flat();
    });
}

/**
 * 绘制热力图 (使用 MapVGL)
 * @param {_MAP} map
 * @param {data} 数据
 */
function drawHotmap(map, data, max=100) {
    if (typeof mapvgl === 'undefined') {
        console.error('mapvgl is not available');
        return null;
    }

    // 创建 MapVGL 视图
    const view = new mapvgl.View({
        map: map
    });

    // 转换数据格式
    const heatmapData = data.map(item => ({
        geometry: {
            type: 'Point',
            coordinates: [item.lng, item.lat]
        },
        properties: {
            count: item.count
        }
    }));

    // 创建热力图层
    const heatmapLayer = new mapvgl.HeatmapLayer({
        size: 50000,
        max: max,
        unit: 'm',
        height: 0,
        gradient: {
            0.0: 'rgba(0, 0, 255, 0)',
            0.5: 'rgba(0, 255, 255, 1)',
            0.7: 'rgba(0, 255, 0, 1)',
            0.9: 'rgba(255, 255, 0, 1)',
            1.0: 'rgba(255, 0, 0, 1)'
        }
    });

    view.addLayer(heatmapLayer);
    heatmapLayer.setData(heatmapData);

    return { view, heatmapLayer };
}

export {
    createMaps,
    drawPolygon,
    drawHotmap,
    drawBoundaryByName,
    drawMultipleBoundaries,
    drawChinaProvinceBoundaries
}